
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehiclefleetapp/[slug]",
      function () {
        return require("private-next-pages/vehiclefleetapp/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehiclefleetapp/[slug]"])
      });
    }
  